import { brandStorage as localStorage } from '@/utils/brandSession';
import { useState, useEffect } from 'react';
import { API } from '../utils/config';

let cached = null;

export function useIsExternalTenant() {
  const [isExternal, setIsExternal] = useState(cached === true);
  useEffect(() => {
    if (cached !== null) { setIsExternal(cached); return; }
    const token = localStorage.getItem('hw_token');
    if (!token) return;
    fetch(`${API}/api/auth/verify`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { cached = !!d?.user?.is_external_tenant; setIsExternal(cached); })
      .catch(() => {});
  }, []);
  return isExternal;
}
